import { render, staticRenderFns } from "./SystemBackstageData.vue?vue&type=template&id=ff3df3a2&scoped=true"
import script from "./SystemBackstageData.vue?vue&type=script&lang=js"
export * from "./SystemBackstageData.vue?vue&type=script&lang=js"
import style0 from "./SystemBackstageData.vue?vue&type=style&index=0&id=ff3df3a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3df3a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff3df3a2')) {
      api.createRecord('ff3df3a2', component.options)
    } else {
      api.reload('ff3df3a2', component.options)
    }
    module.hot.accept("./SystemBackstageData.vue?vue&type=template&id=ff3df3a2&scoped=true", function () {
      api.rerender('ff3df3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemBackstageData/SystemBackstageData.vue"
export default component.exports